const IsFailedCell = ({ value }) => {
  return <div>{value ? 'Yes' : 'No'}</div>;
};

export default IsFailedCell;
